import "./OrdersPrint.style.css";

// Assets
import imageLogo from "../../../logo.png";

// Function
import formatRupiah from "../../../Function/formatRupiah";
import formatDateTime from "../../../Function/formatDateTime";

// React
import { useEffect, useState } from "react";

// React Router Dom
import { useNavigate } from "react-router-dom";

const PageOrdersPrint = () => {
    const navigate = useNavigate();

    const [orderData] = useState(JSON.parse(localStorage.getItem("orderData")));

    useEffect(() => {
        if (orderData) window.print();
        navigate(localStorage.getItem("redirectPage"));
    }, [orderData, navigate]);
    
    const calculateTotal = (dataProduct = []) => {
        if (!Array.isArray(dataProduct)) return 0;

        return dataProduct.reduce((total, item) => {
            const quantity = parseInt(item.product_quantity, 10);
            const price = parseInt(item.product_price ?? 0, 10);

            return total + quantity * price;
        }, 0);
    };

    return (
        <section id="orders-print" className="orders-print">
            <div className="orders-print-header">
                <img src={imageLogo} alt="Aulia Printing" />
            </div>
            <hr className="divider" />
            <div className="d-flex align-items-center justify-content-between">
                <p>{formatDateTime(orderData?.created_at)}</p>
                <p>ORDER#{orderData?.id}</p>
            </div>
            <hr className="divider" />
            <div className="d-flex flex-column gap-2">
                {orderData?.order_products?.map((item, index) => (
                    <div key={index}>
                        <h6>{item?.product_name}</h6>
                        <div className="d-flex align-items-center justify-content-between">
                            <p>{item.product_quantity} x {formatRupiah(item?.product_price)}</p>
                            <p>{formatRupiah(item.product_quantity * item?.product_price)}</p>
                        </div>
                    </div>
                ))}
            </div>
            <hr className="divider" />
            <div className="d-flex align-items-center justify-content-between">
                <p>Total</p>
                <p>{formatRupiah(calculateTotal(orderData?.order_products))}</p>
            </div>
            <div className="d-flex align-items-center justify-content-between">
                <p>Paid ({orderData?.payment})</p>
                <p>{formatRupiah(orderData?.down_payment)}</p>
            </div>
            <div className="d-flex align-items-center justify-content-between">
                <p>Change</p>
                <p>{formatRupiah(orderData?.down_payment - calculateTotal(orderData?.order_products))}</p>
            </div>

            <hr className="divider" />

            {orderData?.description && <p className="mt-2 text-center">{orderData?.description}</p>}

            <p className="mt-3 text-center">Thank you for your purchase! We look forward to serving you again.</p>
        </section>
    )
}

export default PageOrdersPrint